import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';
import { Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-zuggit-cp-dispatch-needs-parts',
    templateUrl: './zuggit-cp-dispatch-needs-parts.component.html',
    styleUrls: ['./zuggit-cp-dispatch-needs-parts.component.scss'],
    standalone: false
})
export class ZuggitCpDispatchNeedsPartsComponent implements OnInit, OnDestroy {
    constructor(private featureFlagService: FeatureFlagService) {
    }
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    ngOnInit(): void {
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setWidgetFilters();
        });
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }

    @Input() chartType: string;
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.zuggitCpDispatchNeedsParts;
    chartSearchFilters: widgetFilters[];

    private setWidgetFilters() {
        this.chartSearchFilters =
            [
                widgetFilters.customer,
                widgetFilters.customerInclusivity,
                widgetFilters.class,
                widgetFilters.state,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.purchaser,
                widgetFilters.acctMgr,
                widgetFilters.contAdmin,
                widgetFilters.svcMgr,
                widgetFilters.priority,
                widgetFilters.biller,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter,
                widgetFilters.status,
                widgetFilters.onCallRegion,
                widgetFilters.svcConst,
                widgetFilters.daysAged,
            ];
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
